export default {
  overseas: "overseas",
  "prod-app": "Open App",
  "uat-app": "UAT App",
  proOps: "ProOps",
  "fat-app": "FAT App",
  "dev-app": "DEV App",
  "local-debug": "LOCAL DEBUG",
  devops: "DevOps",
  other: "Other",
  //------------公共主菜单---------begin--------------/
  "app-officialWebsite": "Official Website",
  "app-businessSystem": "Business System",
  "app-businessSystem1": "中文生产环境",
  "app-businessSystem2": "中文UAT环境",
  "app-businessSystem3": "DEV中文版环境",
  "app-businessSystem4": "DEV海外版环境",
  //------------公共主菜单---------end--------------/
  //------------生产应用---------begin--------------/
  // 办公
  "prod-app-work": "Work",
  "prod-app-sevens-office": "Sevens NAS",
  "prod-app-sevens-cloud-disk": "Sevens Private Cloud Disk(LAN)",
  "prod-app-sevens-oa": "Sevens OA(Not Used)",
  // 官方网站
  "prod-app-sevens": "Sevens Homepage",
  "prod-app-pingworth": "Pingworth Homepage",
  "prod-app-store": "Whaee - Business",
  "prod-app-sensation": "Whatsworth - KOL",
  // 业务系统
  "prod-pw-os": "Pingworth OS",
  "prod-app-whaee-operator": "Whaee - Sevens Operator Entrance",
  "prod-app-admin": "Whaee Management System",
  "prod-app-mms": "MMS",
  "prod-app-kpa": "KPA",
  "prod-app-cpa": "CPA",
  "prod-app-cs": "CS",
  "prod-app-fms": "FMS",
  "prod-app-dms": "DMS",
  "prod-app-dmp": "DMP",
  // 文档资料
  "prod-app-word": "Documentation",
  "prod-whaee-word-navigation": "Whaee Word Navigation",
  "prod-whaee-data-analyze-navigation": "Whaee Data Analyze",
  //------------生产应用---------end--------------/

  //------------海外版---------begin--------------/
  // 文档资料
  "overseas-word": "Documentation - Office",
  "overseas-word-navigation": "Overseas production environment",
  "overseas-office": "Sevens Office(Including public cloud storage)",
  "overseas-cloud-disk": "Qunhui NAS Network Disk",
  // PROD环境
  "overseas-app-prod": "Overseas production environment",
  "overseas-app": "Whaee - Merchant End",
  "overseas-os": "Pingworth OS",
  "overseas-console": "Whaee - Sevens Operator Entrance",
  "overseas-admin": "Whaee Management System",
  "overseas-mms": "MMS",
  "overseas-kpa": "KPA",
  "overseas-cpa": "CPA",
  "overseas-cs": "CS",
  "overseas-fms": "FMS",
  "overseas-dms": "DMS",
  "overseas-dmp": "DMP",
  "overseas-ex": "EX",
  //UAT环境
  "overseas-app-index-uat": "Overseas UAT environment",
  "overseas-app-uat": "Whaee - Merchant End",
  "overseas-os-uat": "Pingworth OS",
  "overseas-console-uat": "Whaee - Sevens Operator Entrance",
  "overseas-admin-uat": "Whaee Management System",
  "overseas-mms-uat": "MMS",
  "overseas-kpa-uat": "KPA",
  "overseas-cpa-uat": "CPA",
  "overseas-cs-uat": "CS",
  "overseas-fms-uat": "FMS",
  "overseas-dms-uat": "DMS",
  "overseas-dmp-uat": "DMP",
  "overseas-ex-uat": "EX",
  // 应用配置
  "overseas-config": "海外版应用配置",
  "overseas-apollo": "海外版apollo",
  "overseas-nexus": "海外版Nexus-共用中文版Nexus",
  "overseas-xxljob": "海外版Xxl-Job",
  "overseas-grafana": "海外版Grafana",
  // 运维
  "overseas-om": "海外版运维中间件",
  "overseas-Jenkins": "海外版Jenkins",
  "overseas-kibana": "海外版Kibana",
  "overseas-sonarqube": "海外版Sonarqube",
  "overseas-grafana": "海外版Grafana",

  //------------海外版---------end--------------/

  //------------uat应用---------begin--------------/
  // 业务系统
  "uat-pw-os": "Pingworth OS",
  "uat-app-whaee-operator": "Whaee - Sevens Operator Entrance",
  "uat-app-admin": "Whaee Management System",
  "uat-app-mms": "MMS",
  "uat-app-kpa": "KPA",
  "uat-app-cpa": "CPA",
  "uat-app-cs": "CS",
  "uat-app-fms": "FMS",
  "uat-app-dms": "DMS",
  "uat-app-dmp": "DMP",
  // 官方网站
  "uat-app-store": "Whaee - Merchant",
  "uat-app-sensation": "Whatsworth - KOL",
  // 旧版哇鹅
  "uat-app-old-whaee": "Old Whaee (Before 2022-05)",
  "uat-app-old-store-index": "Old Merchant - PC Index",
  "uat-app-old-store-console": "Old Merchant - Console",
  "uat-app-old-store-h5-index": "Old Merchant - H5 Index",
  "uat-app-old-admin": "Old Admin",
  "uat-app-old-sensation-index": "Old KOL - PC Index",
  "uat-app-old-sensation-console": "Old KOL - Console",
  "uat-app-old-sensation-h5-index": "Old KOL - H5 Index",
  //------------uat应用---------end--------------/

  //------------生产运维---------begin--------------/
  // 运维
  "proOps-operation": "Operation",
  "proOps-kibana": "Kibana",
  "proOps-kiali": "Kiali",
  "proOps-grafana": "Grafana",
  "proOps-prometheus": "Prometheus",
  "proOps-en-kibana": "US-Whaee-job-Kibana",
  // 基础支持
  "proOps-base-support": "Base Support",
  "proOps-apollo": "Apollo",
  "proOps-otter": "Otter",
  "proOps-xxl-job": "XXL-JOB",
  "proOps-es-head": "Elasticsearch-head",
  "proOps-dolphinscheduler": "DolphinScheduler",

  "proOps-czsm": "运维文档",
  "proOps-fbsq": "发版申请",
  "proOps-gdsh": "工单审核",
  "proOps-item": "运维文档目录",
  //工单审核地址
  "proOps-archery": "工单审核",
  //------------生产运维---------end--------------/

  //------------fat应用---------begin--------------/
  // 业务系统
  "fat-pw-os": "Pingworth OS",
  "fat-app-whaee-operator": "Whaee - Sevens Operator Entrance",
  "fat-app-admin": "Whaee Management System",
  "fat-app-mms": "MMS",
  "fat-app-kpa": "KPA",
  "fat-app-cpa": "CPA",
  "fat-app-cs": "CS",
  "fat-app-fms": "FMS",
  "fat-app-dms": "DMS",
  "fat-app-dmp": "DMP",
  // 官方网站
  "fat-app-store": "Whaee - Business",
  "fat-app-sensation": "Whatsworth - KOL",
  //------------fat应用---------end--------------/
  //------------dev应用---------begin--------------/
  // 业务系统
  "dev-pw-os": "Pingworth OS",
  "dev-app-whaee-operator": "Whaee - Sevens Operator Entrance",
  "dev-app-admin": "Whaee Management System",
  "dev-app-mms": "MMS",
  "dev-app-kpa": "KPA",
  "dev-app-cpa": "CPA",
  "dev-app-cs": "CS",
  "dev-app-fms": "FMS",
  "dev-app-dms": "DMS",
  "dev-app-dmp": "DMP",
  "dev-rag-bs": "RAG",
  // 官方网站
  "dev-app-sensation": "Whatsworth - KOL",
  "dev-app-store": "Whaee - Business",
  "dev-whaee-help": "Whaee - Help Center",
  // 第三方开发者平台
  "dev-app-third-dev-platform": "Third Party Developer Platform",
  "dev-app-google-dev": "Google Dev",
  "dev-app-amazon-attribution": "Amazon Attribution",
  "dev-app-shopify-dev": "Shopify Dev",
  "dev-app-tiktok-dev": "TikTok Dev",
  "dev-app-facebook-dev": "Facebook Dev",
  //------------dev应用---------end--------------/
  //------------local调试---------begin--------------/
  // 后端调试
  "back-debug": "Back Debug",
  "local-debug-whaee-v2console": "Whaee - Business v2 Console",
  //------------local调试---------end--------------/
  //------------开发运维---------begin--------------/
  // 项目管理
  "devops-project-management": "Project Management",
  "devops-pingcode": "PingCode",
  "devops-wiki": "Wiki",
  "devops-it-library": "Pingworth IT Library",
  // 产品&UI
  "devops-Product-UI": "Product&UI",
  "devops-yuque": "Yuque",
  "devops-ui-link-navigation": "UI Link Navigation",
  "devops-lanhu": "Lanhu",
  "devops-Figma": "Figma",
  // 开发协同
  "devops-collaboration": "Develop Collaborative",
  "devops-swagger": "Swagger API (Merchant)",
  "devops-yapi": "YApi",
  "devops-GitLab": "GitLab",
  // 部署&运维
  "devops-deploy-operation": "Deploy&Operation",
  "devops-kubesphere": "KubeSphere",
  "devops-kibana": "Kibana",
  "devops-kiali": "Kiali",
  "devops-grafana": "Grafana",
  "devops-prometheus": "Prometheus",

  // 基础支持
  "devops-base-support": "Base Support",
  "devops-apollo": "Apollo",
  "devops-otter": "Otter",
  "dev-xxl-job": "dev-xxl-job",
  "devEN-xxl-job": "devEN-xxl-job",
  "devops-es-head": "Elasticsearch-head",
  "devops-nexus": "Nexus",
  "devops-dolphinscheduler": "dev-DolphinScheduler",
  "devops-LAN": "Pingwork Network",
  //------------开发运维---------end--------------/
  //------------其他---------begin--------------/
  // 其他-广告平台
  "other-ads-platform": "Ads Platform",
  "other-google-ads": "Google Ads",
  "other-amazon-ads": "Amazon Ads",
  "other-tiktok-ads": "TikTok Ads",
  "other-facebook-ads": "Facebook Ads Management",
  // 常用工具
  "other-commonTools": "Common Tools",
  "other-online-tools": "Online Tools",
  "other-tool": "IT Online Tools",
  "other-json": "JSON Editor",
  "other-img-del-bottom": "Online Img Del Bottom",
  "other-img-to-ico": "Online Img To Ico",
  "other-docker-hub": "Docker Hub",
  "other-aliMaven": "Aliyun Maven Warehouse",
  "other-apacheMaven": "Apache Maven Warehouse",
  "other-msdn": "MSDN Tools",
  "other-google-trans": "Google Translate",
  "other-youdao-trans": "Youdao Translate",
  "other-baidu-trans": "Baidu Translate",
  "other-ali-iconfont": "Ali Iconfont",
  // 服务平台
  "other-servicePlatform": "Service Platform",
  "other-aliCloud": "Aliyun",
  "other-ali-email": "Ali Email",
  "other-QQemail": "Tencent Exmail",
  //------------其他---------end--------------/
};



// WEBPACK FOOTER //
// ./src/lang/en.js